import { getData, postData } from '@/utils/http';
export default {
  namespaced: true,
  state: {
    detailId: '',
    activeItem: {},
    activeTab: 'inner',
    isVerify:false,
  },
  mutations: {
    CHANGE_ACTIVE_ITEM(state, item) {
      state.activeItem = item;
      console.log(state.activeItem.address);
    },
    CHANGE_DETAIL_ID(state, value) {
      state.detailId = value;
    },
    CHANGE_ACTIVE_TAB(state, value) {
      state.activeTab = value;
    },
       CHANGE_IS_REVIEW(state, value) {
      state.isVerify = value;
    },
  },
  actions: {
    setTabData({ commit }, changeData) {
      commit('CHANGE_ACTIVE_TAB', changeData);
    },
    getDetail({ commit, state }) {
      return new Promise((resolve) => {
        getData(`platform/auth/apply/get/${state.detailId}`).then((res) => {
          if (res.state == 1) {
            commit('CHANGE_ACTIVE_ITEM', res.data);
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
    examine({}, data) {
      return new Promise((resolve) => {
        postData('platform/auth/apply/examine', data).then((res) => {
          if (res.state == 1) {
            resolve({
              state: 1,
              msg: '操作成功',
            });
          } else {
            resolve({
              state: 0,
              msg: res.msg,
            });
          }
        });
      });
    },
  },
};
